import Dexie from 'dexie'

export const dataBase = new Dexie('MerchClientDB')

dataBase.version(1).stores({
  projects: 'id, cachedAt',
  networks: 'id, projectId, cachedAt',
  points:   'id, projectId, networkId, [networkId+projectId], cachedAt',
  products: 'id, pointId, networkId, projectId, [pointId+networkId], cachedAt',
  categories: 'id, name, pointId, networkId, cachedAt',
  reports:  '++id, serverId, productId, pointId, networkId, projectId, synced, updatedAt',
  photos:   '++id, reportId, serverId, synced',
})

export default dataBase